import { useGetAllInvoiceComments } from "@/queries/invoice-comments/get-all";

import { ErrorMessage } from "@/components/ui/error";
import { LoadingSpinner } from "@/components/ui/spinner";

import { CommentInput } from "./comment-input";
import { InvoiceComments as InvoiceCommentsComponent } from "./invoice-comments";

type Props = {
  invoiceId: string;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  disableInput?: boolean;
};

export const InvoiceComments = ({
  invoiceId,
  className,
  disableInput = false,
}: Props) => {
  const { invoiceComments, loading, error, refetch } = useGetAllInvoiceComments(
    {
      invoiceId,
    },
  );

  if (loading) return <LoadingSpinner />;

  if (error) return <ErrorMessage retry={refetch} />;

  return (
    <div className="flex flex-col gap-4 h-full">
      <InvoiceCommentsComponent
        comments={invoiceComments}
        className={className}
      />
      {!disableInput && <CommentInput invoiceId={invoiceId} />}
    </div>
  );
};
